import { Environment } from './Environment.enum'
import { contractAddresses } from './addresses'

export function getAddressesConfig(chainId?: string | number) {
  const _chainId = String(chainId ?? process.env.NEXT_PUBLIC_CHAIN_ID ?? '')

  // Base Sepolia: always return a concrete map (dev | stage), never the parent object.
  // Missing/unknown NEXT_PUBLIC_ENVIRONMENT (e.g. beta, typo) would otherwise break lookups.
  if (_chainId === '84532') {
    const sepolia = contractAddresses['84532']
    const environment = process.env.NEXT_PUBLIC_ENVIRONMENT
    const tier: 'dev' | 'stage' =
      environment === 'stage' || environment === 'dev' ? environment : Environment.DEV
    return sepolia[tier]
  }

  // Base mainnet: only `production` exists; avoid returning the raw `{ get production() }` shell.
  if (_chainId === '8453') {
    return contractAddresses['8453'].production
  }

  const environment = getEnvironment(Number(_chainId))

  return !environment
    ? contractAddresses[_chainId as keyof typeof contractAddresses]
    : (
        contractAddresses[_chainId as keyof typeof contractAddresses] as Record<
          string,
          unknown
        >
      )[environment]
}

export function getProductionWlthAddresses(prodChainId: number) {
  return contractAddresses[prodChainId][Environment.PROD].Wlth
}

export function getEnvironment(chainId?: number) {
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT

  if (chainId === 31337) {
    return null
  }
  if (environment && !checkIfEnvironmentExists(environment)) {
    throw new Error(`Unknown environment ${environment}.`)
  }

  return environment
}

function checkIfEnvironmentExists(value: string) {
  return Object.values(Environment)
    .map((env) => env.toString())
    .includes(value)
}

export const getNetworkName = (): {
  shortName: string
  fullName: string
} => {
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT

  if (
    [Environment.DEV, Environment.STAGE, Environment.BETA].includes(
      environment as Environment,
    )
  ) {
    return {
      shortName: 'Base',
      fullName: 'Base Sepolia Testnet',
    }
  }

  return {
    shortName: 'Base',
    fullName: 'Base Mainnet',
  }
}
